import moment from 'moment';
import React from 'react';
import axios from 'axios';
const analyzeLink = async link => {
    const links = link.startsWith('http') ? link : `http://${link}`;
    // eslint-disable-next-line no-undef
    const res = await axios(`${linkBasePath}/outLink/handleOutLink?link=${encodeURIComponent(links)}`);

    return res;
};

// 用户传入秒数，返回给用户XX(小时):XX(分钟):XX(秒)的数据格式
export const timeFormat = time => {
    let newTime = '';
    let hour = '';
    let minite = '';
    let seconds = '';

    if (time >= 3600) {
        hour = parseInt(time / 3600) < 10 ? `0${parseInt(time / 3600)}` : parseInt(time / 3600);
        minite = parseInt((time % 60) / 60) < 10 ? `0${parseInt((time % 60) / 60)}` : parseInt((time % 60) / 60);
        seconds = parseInt(time % 3600) < 10 ? `0${parseInt(time % 3600)}` : parseInt(time % 3600);
        newTime = `${hour}:${minite}:${seconds}`;
    } else if (time >= 60 && time < 3600) {
        minite = parseInt(time / 60) < 10 ? `0${parseInt(time / 60)}` : parseInt(time / 60);
        seconds = parseInt(time % 60) < 10 ? `0${parseInt(time % 60)}` : parseInt(time % 60);
        newTime = `${minite}:${seconds}`;
    } else if (time < 60) {
        seconds = parseInt(time) < 10 ? `0${parseInt(time)}` : parseInt(time);
        newTime = `00:${seconds}`;
    }

    return newTime;
};

//const u = window.navigator.userAgent;

export const isIOS = true;

// 本地开发时不验证权限
export const browserRedirect = () => {
    return process.env.NODE_ENV !== 'development';
};

// 用户传入时间例如2021-07-10 13:00:33
// 如果传入时间距离当前时间超过24小时则展示XX天前
// 如果传入时间距离当前时间超过1小时但不超过24小时，则展示XX小时前
// 如果传入时间距离当前时间不超过1小时，则展示XX分前
export const formatTimeNoYear = date => {
    const milliSeconds = moment(date).isAfter(moment())
        ? moment.duration(moment(date).diff(moment()))
        : moment.duration(moment().diff(moment(date)));
    let hours = 0;
    let minutes = 0;

    hours = parseInt(milliSeconds.asHours());
    if (hours >= 24) {
        // eslint-disable-next-line react/jsx-filename-extension
        return <span title={moment(date).format('MM-DD HH:mm')}>{`${parseInt(milliSeconds.asDays())}天前`}</span>;
    } else {
        const newMilliSeconds = milliSeconds.subtract(hours, 'h');

        minutes = Math.ceil(newMilliSeconds.asMinutes());

        return (
            <span title={moment(date).format('MM-DD HH:mm')}>{`${hours ? `${hours}小时` : ''}${
                minutes && !hours ? `${minutes}分` : ''
            }前`}</span>
        );
    }
};

// 获取地址栏拼接的参数，生成对象
// export const getUrlParams = () => {
//     const paramsStrArr = window.location.search.substring(1).split('&');
//     const params = {};
//
//     paramsStrArr.forEach(item => {
//         const keyValue = item.split('=');
//
//         params[keyValue[0]] = keyValue[1];
//     });
//
//     return params;
// };

// 将object转换为地址栏参数格式，返回地址栏拼接参数
export const formatObjToUrlParams = obj => {
    const keys = Object.keys(obj);

    if (keys.length === 0) {
        return '';
    }

    return keys
        .filter(key => obj[key] || obj[key] === 0)
        .map(key => `${key}=${obj[key]}`)
        .join('&');
};

// 判断是否在微信环境
export const isWeChat = () => {
    // const ua = window.navigator.userAgent.toLowerCase();
    // // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
    //
    // if (ua.indexOf('micromessenger') !== -1) {
    //     return true;
    // } else {
    //     return false;
    // }
    return false
};

export const replaceSrc = async (txt, link) => {
    // eslint-disable-next-line no-useless-escape
    const reg = /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
    let num = -1;
    const reqArr = link ? link.map(item => analyzeLink(item)) : null;
    let formatStr = txt;

    const linkRes = reqArr
        ? await Promise.all(reqArr).then(res => {
              formatStr = formatStr.replace(reg, item => {
                  // eslint-disable-next-line space-unary-ops
                  num++;

                  // IOS微信浏览器页面跳转window.open或者window.location不生效，添加a标签模拟点击可以生效
                  // 对应src/client/components/Text/replaceText.jsx中的e.target.nextSibling.click()触发
                  return isWeChat()
                      ? `<span style="color: #3091f5;" id="link" link=${link[num]}>${res[num]?.data?.data?.title ||
                            item}</span><a href=${link[num]} target="_self"></a>`
                      : `<span style="color: #3091f5;" id="link" link=${link[num]}>${res[num]?.data?.data?.title ||
                            item}</span>`;
              });

              return formatStr;
          })
        : txt;

    return linkRes;

    // const result = txt.replace(reg, item => {
    //     // eslint-disable-next-line space-unary-ops
    //     num++;
    //     // const linkname = link[num].startsWith('http') ? link[num] : `http://${link[num]}`;

    //     // return analyzeLink(linkname).then(res => {
    //     //     return res.data.data.title;
    //     // });

    //     return `<span style="color: #3091f5;" id="link" link=${link[num]}>${item}</span>`;
    // });

    // return result;
};

export const getLink = txt => {
    // eslint-disable-next-line no-useless-escape
    const reg = /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;

    return Array.isArray(txt.match(reg))
        ? txt.match(reg).map(innerText => (innerText.startsWith('http') ? innerText : `http://${innerText}`))
        : txt.match(reg);
};

// 专门为前端回显功能写的方法
export const setLocalStorage = (key, id) => {
    try {
        if (!localStorage.getItem(key)) {
            return;
        }
        const { ids, uuid } = JSON.parse(localStorage.getItem(key)) || {};
        const contentArr = Object.keys(ids);

        if (!(Array.isArray(contentArr) && contentArr.length > 0 && contentArr?.indexOf(id) > -1)) {
            return;
        }
        delete ids[id];

        localStorage.setItem(key, JSON.stringify({ ids, uuid }));
    } catch (e) {
        console.log(e);
    }
};
// 获取上拉加载observer的文字
export const getStateText = (isLoading, isError, isEnd, requestEnd, listLength) => {
    // 如果请求结束并且无数据，则不展示，避免和 NoData 组件展示重复
    if (requestEnd && listLength === 0) {
        return '';
    }
    if (isLoading) {
        return '数据加载中...';
    }
    if (isError) {
        return '加载失败，点击重试';
    }
    if (isEnd) {
        return '已显示全部内容';
    }

    return '';
};

// 圈友人数单位转换
export const numFormat = number => {
    if (!number) {
        return '0位';
    }
    const num = Number(number);

    if (num > 99999999) {
        return `${(num / 100000000).toFixed(1)}亿`;
    } else if (num > 9999) {
        return Number((num / 10000).toFixed(1)) === 10000 ? '9999.9万' : `${(num / 10000).toFixed(1)}万`;
    }

    return `${num}位`;
};
